import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Avatar from '~components/avatar';
import { SkeletonSimple } from '~components/skeleton';
import { renderFirstName, stringToJSON } from '~helpers/common';

import { UserContext } from '~contexts/user';

import './style.scss';

const Connections = ({ connections = [] }) => {
  const { user } = useContext(UserContext);

  return (
    <div className="c-connections">
      {connections.map((c) => {
        const con =
          c.participants && c.participants.length > 1 ? c.participants.find((f) => f.id !== user.personId) : null;
        return con ? (
          <Link to={`/discussion/${con.id}`} key={con.id} className="c-connections__item">
            <Avatar
              profilePicture={stringToJSON(con.profile_picture)}
              firstName={con.first_name}
              className="c-connections__photo"
            />
            <div className="c-connections__name l-truncate notranslate" style={c.acceptance_state==='rejected' ? {lineHeight: '1'} : c.acceptance_state==='pending' ? {lineHeight: '1'} : {}}>{renderFirstName(con.first_name)} <br />
                {c.acceptance_state == 'rejected' && <span className="c-connections__status" style={{color: 'red'}}>{c.acceptance_state}</span>}
                {c.acceptance_state == 'pending' && <span className="c-connections__status" style={{color: 'orange'}}>{c.acceptance_state}</span>}
            </div>
            {con.hasUnreadMessages && <div className="c-badge c-connections__badge" />}
          </Link>
        ) : null;
      })}
    </div>
  );
};

export const ConnectionsSkeleton = ({ itemCount = 2 }) => {
  return (
    <div className="c-connections">
      {Array(itemCount)
        .fill()
        .map((c, index) => (
          <SkeletonSimple
            theme="primary"
            key={index}
            className="c-skeleton-simple__item c-skeleton-simple__connections-item"
          />
        ))}
    </div>
  );
};

export default Connections;
